module.exports = __webpack_public_path__ + "img/09.dff48947.png";